<template>
  <div class="space-y-2">
    <label for="projectId" class="label" @click="toggleFinder"> Project </label>
    <QuickFinder
      ref="finder"
      v-model="project"
      :items="options"
      :loading="fetching"
      label="name"
      @changed="search"
    >
      <template #item="{ item }">
        <div class="flex px-2 pb-2 group">
          <div class="flex-1 p-4 group-hover:bg-indigo-500 group-hover:text-white rounded">
            {{ item.name }}
          </div>
        </div>
      </template>
    </QuickFinder>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import QuickFinder from '@/components/Ui/QuickFinder.vue';

export default {
  name: 'ProjectFinder',
  components: {
    QuickFinder,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    prefetch: Boolean,
    action: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...mapState('entities', {
      projectsById: (state) => state.projects.byId,
    }),
    project: {
      set(project) {
        this.$emit('input', project.uuid);
      },
      get() {
        return this.projectsById[this.value] || null;
      },
    },
  },
  created() {
    if (this.prefetch) {
      this.search('');
    }
  },
  methods: {
    ...mapMutations('ui/projects', ['setIds']),
    ...mapActions('ui/projects', ['fetchProjectList']),
    toggleFinder() {
      this.$refs.finder.toggleList();
    },
    search(search) {
      this.fetching = true;
      this.action(search)
        .then(() => {
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
  },
};
</script>
